<template>
  <div>
    <div class="all-wrapper with-side-panel solid-bg-all">
      <div class="content-w w-100">
        <router-view/>
      </div>
    </div>
  </div>
</template>
<script>
import MainMenu from '@/components/app/user/partials/navbar/web/mainMenu'
import RightMenu from '@/components/app/user/partials/navbar/web/rightMenu'
import userContact from '@/components/app/user/partials/navbar/web/userContact'
import { mapState } from 'vuex'

export default {
	name: 'container',
	components: { MainMenu, RightMenu, userContact },
	data () {
		return {
			Menucolor: 'rgb(238, 238, 238)',
			MenuTopcolor: 'rgb(255, 87, 34)',
			active: false,
			on: false
		}
	},
	computed: {
		...mapState('ThemePreferences', ['subMenuColor']),
		...mapState('ThemePreferences', ['menuColor']),
		...mapState('ThemePreferences', ['menuAnnimation']),
		...mapState('ThemePreferences', ['menuLayout']),
		...mapState('ThemePreferences', ['menuPosition']),
		...mapState('ThemePreferences', ['fullScreen']),
		...mapState('ThemePreferences', ['topBar']),
		...mapState('ThemePreferences', ['menuImage']),
		...mapState('ThemePreferences', ['subTopbarColor'])
	},
	methods: {
		changeMenuColor () {
			this.$store.commit(`ThemePreferences/setMenuColor`, this.Menucolor)
		},
		changeTopMenuColor () {
			this.$store.commit(`ThemePreferences/setTopbarColor`, this.MenuTopcolor)
		}
	}
}
</script>
<style scoped>
.menu-right-fixed .logged-user-menu.color-style-bright {
    display: none!important;
}

</style>



// WEBPACK FOOTER //
// src/components/app/user/partials/container/index.vue